import CLAIMS_CFG from '../../config/claims-date.js';

const rawStart = CLAIMS_CFG.latestClaimsDate ?? CLAIMS_CFG;

const end = new Date(rawStart);  
const start   = new Date(end);
start.setFullYear(end.getFullYear() - 1);

export const CLAIMS_RANGE_MSG =
  'Claims data available from ' +
  `${start.toISOString().slice(0,10)} through ${end.toISOString().slice(0,10)}.`;